
import { Options, Vue } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import { IFlexMessageBubble, IFlexMessageURIAction } from '@/utils/types'
import Action from '@/components/common/flex-message/forms/Action.vue'

@Options({
  components: { Action },
  directives: { maska },
  emits: ['update:modelValue', 'update:altText', 'update:validateValue'],
})
export default class Bubble extends Vue {
  @Prop()
  modelValue!: IFlexMessageBubble

  @Prop()
  altText!: string

  @Prop()
  isParent!: boolean

  @Prop()
  isAdmin!: boolean

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageBubble) {
    this.$emit('update:modelValue', value)
  }

  get currentAltText() {
    return this.altText
  }

  set currentAltText(value: string) {
    this.$emit('update:altText', value)
  }

  get requiredRule() {
    return {
      altText: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.common.answer.alt_text'),
      }),
    }
  }

  get directionList() {
    return [
      {
        label: '左寄せ',
        value: 'ltr',
      },
      {
        label: '右寄せ',
        value: 'rtl',
      },
    ]
  }

  get typeList() {
    return [
      {
        label: 'カルーセル',
        value: 'carousel',
      },
      {
        label: 'バブル',
        value: 'bubble',
      },
    ]
  }

  get sizeList() {
    return ['giga', 'mega', 'kilo', 'hecto', 'deca', 'micro', 'nano']
  }

  @Watch('currentAltText')
  async validate() {
    await this.$nextTick(async () => {
      const isValid = await this.$refs.formRef.validate()
      if (isValid) {
        this.$emit('update:validateValue', true)
      } else {
        this.$emit('update:validateValue', false)
      }
      return isValid
    })
  }

  mounted() {
    if (this.value.action) {
      if (this.value.action.type === 'uri') {
        const uriAction: IFlexMessageURIAction = {
          type: 'uri',
          label: 'action',
          uri: 'http://linecorp.com/',
          altUri: {
            desktop: '',
          },
        }
        this.value.action = { ...uriAction, ...this.value.action }
      }
    }
    this.validate()
  }
}
